<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>El gobierno provisional y el primer Imperio</h2>
    <img @click="imageClicked(0)" src="galerias/independencia/g10/G10.jpg" class="mainphoto"/>
    <p class="photo-description">Alegoría de la Patria / Ana María Huarte como imagen del Imperio Mexicano. Autor anónimo, óleo sobre tela, 1822. Col.  Museo del Estado “Casa de Alfeñique”</p>
    <p>Una de las primeras acciones de la Junta Provisional Gubernativa fue la elección de diputados para constituir el Primer Congreso Mexicano, que inició trabajos el 24 de febrero de 1822, sin embargo, la difícil situación económica sumada a la inexperiencia de Iturbide en temas políticos orillaron a que el Congreso buscara una solución rápida para el control político: el nombramiento de Agustín de Iturbide como primer Emperador de México, el cual se coronó el 21 de julio de ese año.</p>      
    <p>La imagen muestra a la esposa de Iturbide, Ana María Huarte, como emperatriz vistiendo un atuendo simbólico con los colores que representaban al Ejército Trigarante, verde, blanco y rojo, que serán transformados en la bandera del naciente país.</p>      
    <h5>VER MÁS</h5>      
    <p>Consulta información adicional en los siguientes links
    <ul><li><a target="_blank" href="https://mediateca.inah.gob.mx/islandora_74/islandora/object/pintura%3A4114">mediateca.inah.gob.mx</a></li>
    <li><a target="_blank" href="https://archivos.juridicas.unam.mx/www/bjv/libros/7/3358/5.pdf">archivos.juridicas.unam.mx</a></li>
    <li><a target="_blank" href="https://www.historicas.unam.mx/publicaciones/publicadigital/libros/historia_documental/v02/593t2c_04_01_independencia.pdf">historicas.unam.mx</a></li></ul></p>
  </div>
</template>

<script>
export default {
  name: "Sala3m12",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    },
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
